/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

class AppDefault extends Component<any> {
  render() {
    const isLoginPage = this.props.location.pathname === '/login';
    const containerClass = isLoginPage ? 'fill-viewport' : 'container fill-viewport';
    
    return (
      <div>
        <div className={containerClass}>{this.props.children}</div>
      </div>
    );
  }
}

export default withRouter(AppDefault as any);
